import React from "react";

export default function SubInputBarraBusqueda({ onSearch,setVIsFocus=()=>{} }) {
  return (
    <div class="box-menu-organizacion-input">
      <img
        src="images/search-3-1.svg"
        data-figma-id="113:9509"
        class="icon-busqueda"
      />
      <input
        type="text"
        placeholder="Buscar"
        data-figma-id="5381:19931"
        class="menu-organizacion-texto"
        onChange={(e) => onSearch(e.target.value)}
        onFocus={()=>setVIsFocus(true)}
        onBlur={()=>setTimeout(() => {
          setVIsFocus(false)
        }, 150)}
      />
    </div>
  );
}
